// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.min-height-vh-triggered {
  min-height: 800px;
  overflow: auto;
  height: calc(100vh - 110px);
  max-height: calc(100vh - 110px);
}

.status-circle {
  border-radius: 50%;
  width: 10px;
  height: 10px;
}

.status-text {
  font-size: 0.7rem;
}

.circle-avatar {
  background-color: #5365c5;
  color: #fff;
  margin: 1rem 0;
  border-radius: 50%;
  height: 4rem;
  text-align: center;
  width: 4rem;
}

.initials-avatar {
  font-size: 2rem; /* 50% of parent */
  line-height: 1;
  position: relative;
  top: 1rem; /* 25% of parent */
}

.card-profile-image {
  position: relative;
}

.card-profile-image img {
  max-width: 60px;
  max-height: 60px;
  border-radius: 0.25rem;
  transform: translate(0%, -30%);
  position: absolute;
  transition: all 0.2s ease-in-out;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}

.card-profile-stats > div {
  text-align: center;
  margin-right: 1rem;
  padding: 0.875rem;
}

.card-profile-stats > div .heading {
  font-size: 1rem;
  font-weight: 500;
  display: block;
  letter-spacing: 0.025em;
  text-transform: uppercase;
}

.card-profile-stats > div .description {
  font-size: 0.875rem;
  color: #111;
}

.badge-secondary {
  color: #fff;
  background-color: #5365c5;
}

.accepted-btn {
  background-color: #2E562E;
  border-color: #006300;
  color: #fff;
}

.rejected-btn {
  background-color: #A72925;
  border-color: #d9534f;
  color: #fff;
}

.disabilities_container {
  font-size: 1.5rem;
}

.headings {
  background-color: rgba(159, 170, 229, 0.5019607843);
  color: #111;
  padding: 0.5rem 0;
  margin: 1rem 0 0.5rem 0;
  font-weight: 500;
  border-radius: 5px;
}

.flex-grow-container {
  display: flex;
  flex-grow: 1;
  align-items: center;
}

.map-card {
  border-bottom: solid 2px #3f51b5;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
}

.toPdf {
  padding-left: 20px;
  color: #A72925;
}

.card-inactive {
  margin-top: 1.5rem;
  border-left: 4px solid #ffc107;
  background-color: #fff8e1;
}
.card-inactive .card-title {
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
  font-size: 1rem;
}
.card-inactive .info-icon {
  color: #ffc107;
}`, "",{"version":3,"sources":["webpack://./src/app/admin/dashboard/user-profile/user-profile.component.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;EACA,cAAA;EAGA,2BAAA;EACA,+BAAA;AADJ;;AAMA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;AAHJ;;AAMA;EACI,iBAAA;AAHJ;;AAOA;EACI,yBAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AAJJ;;AAOA;EACA,eAAA,EAAA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA,EAAA,kBAAA;AAJA;;AAOA;EACI,kBAAA;AAJJ;;AAOA;EACI,eAAA;EACA,gBAAA;EACA,sBAAA;EAEA,8BAAA;EACA,kBAAA;EAEA,gCAAA;EACA,wDAAA;AALJ;;AAYA;EACI,kBAAA;EACA,kBAAA;EACA,iBAAA;AATJ;;AAYA;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,uBAAA;EACA,yBAAA;AATJ;;AAYA;EACI,mBAAA;EACA,WAAA;AATJ;;AAYA;EACI,WAAA;EACA,yBAAA;AATJ;;AAYA;EACI,yBAAA;EAEA,qBAAA;EACA,WAAA;AAVJ;;AAaA;EACI,yBAAA;EAEA,qBAAA;EACA,WAAA;AAXJ;;AAcA;EACI,iBAAA;AAXJ;;AAcA;EAII,mDAAA;EACA,WAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EAIA,kBAAA;AAjBJ;;AAoBA;EACI,aAAA;EACA,YAAA;EACA,mBAAA;AAjBJ;;AAoBA;EACI,gCAAA;EACA,8BAAA;EACA,+BAAA;AAjBJ;;AAoBE;EACE,kBAAA;EACA,cAAA;AAjBJ;;AAqBC;EACI,kBAAA;EACA,8BAAA;EACA,yBAAA;AAlBL;AAoBK;EACI,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,eAAA;AAlBT;AAqBK;EACI,cAAA;AAnBT","sourcesContent":[".min-height-vh-triggered {\r\n    min-height: 800px;\r\n    overflow: auto;\r\n    // height: calc(100vh - 110px - 0.25rem);\r\n    // max-height: calc(100vh - 110px - 0.25rem);\r\n    height: calc(100vh - 110px);\r\n    max-height: calc(100vh - 110px);\r\n\r\n}\r\n\r\n\r\n.status-circle {\r\n    border-radius: 50%;\r\n    width: 10px;\r\n    height: 10px;\r\n}\r\n\r\n.status-text {\r\n    font-size: 0.7rem;\r\n    // color: #adb5bd;\r\n}\r\n\r\n.circle-avatar {\r\n    background-color: #5365c5;\r\n    color: #fff;\r\n    margin: 1rem 0;\r\n    border-radius: 50%;\r\n    height: 4rem;\r\n    text-align: center;\r\n    width: 4rem;\r\n  }\r\n\r\n.initials-avatar {\r\nfont-size: calc(4rem / 2); /* 50% of parent */\r\nline-height: 1;\r\nposition: relative;\r\ntop: calc(4rem / 4); /* 25% of parent */\r\n}\r\n\r\n.card-profile-image {\r\n    position: relative;\r\n}\r\n\r\n.card-profile-image img {\r\n    max-width: 60px;\r\n    max-height: 60px;\r\n    border-radius: 0.25rem;\r\n    -webkit-transform: translate(0%, -30%);\r\n    transform: translate(0%, -30%);\r\n    position: absolute;\r\n    // left: 50%;\r\n    transition: all 0.2s ease-in-out;\r\n    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;\r\n}\r\n\r\n// .card-profile-stats {\r\n//     padding: .5rem 0;\r\n// }\r\n\r\n.card-profile-stats > div {\r\n    text-align: center;\r\n    margin-right: 1rem;\r\n    padding: .875rem;\r\n}\r\n\r\n.card-profile-stats > div .heading {\r\n    font-size: 1rem;\r\n    font-weight: 500;\r\n    display: block;\r\n    letter-spacing: 0.025em;\r\n    text-transform: uppercase;\r\n}\r\n\r\n.card-profile-stats > div .description {\r\n    font-size: .875rem;\r\n    color: #111;\r\n}\r\n\r\n.badge-secondary {\r\n    color: #fff;\r\n    background-color: #5365c5;\r\n}\r\n\r\n.accepted-btn {\r\n    background-color: #2E562E;\r\n    // color: #449d44;\r\n    border-color: #006300;\r\n    color: #fff;\r\n}\r\n\r\n.rejected-btn {\r\n    background-color: #A72925;\r\n    // color: #d9534f;\r\n    border-color: #d9534f;\r\n    color: #fff;\r\n}\r\n\r\n.disabilities_container {\r\n    font-size: 1.5rem;\r\n}\r\n\r\n.headings {\r\n    // background-color: #fff3cd;\r\n    // background-color: #5365c5;\r\n    // color: #fff;\r\n    background-color: #9faae580;\r\n    color: #111;\r\n    padding: .5rem 0;\r\n    margin: 1rem 0 .5rem 0;\r\n    font-weight: 500;\r\n    // border-radius: 15px;\r\n    // border-bottom-left-radius: 5px;\r\n    // border-bottom-right-radius: 5px;\r\n    border-radius: 5px\r\n}\r\n\r\n.flex-grow-container {\r\n    display: flex;\r\n    flex-grow: 1;\r\n    align-items: center;\r\n}\r\n\r\n.map-card {\r\n    border-bottom: solid 2px #3f51b5;\r\n    border-bottom-left-radius: 3px;\r\n    border-bottom-right-radius: 3px;\r\n  }\r\n\r\n  .toPdf{\r\n    padding-left: 20px;\r\n    color: #A72925;\r\n    // margin-left: 10px;\r\n  }\r\n\r\n .card-inactive {\r\n     margin-top: 1.5rem;\r\n     border-left: 4px solid #ffc107; \r\n     background-color: #fff8e1;\r\n\r\n     .card-title {\r\n         display: flex;\r\n         align-items: center;\r\n         margin-bottom: 0.5rem;\r\n         font-size: 1rem;\r\n     }\r\n\r\n     .info-icon {\r\n         color: #ffc107;\r\n     }\r\n }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
